export default "__VITE_ASSET__Cylfl_qR__"